import React from "react";
import { useHistory } from "react-router-dom";
//Limitless imports
import { useCustomerMessageContext, useCustomerContext } from "@limitless/customer/hooks";
import { useResources } from "@limitless/common/hooks";

export const useCustomerAutoSubmit = () => {
    const [autoSubmit, setAutoSubmit] = React.useState({
        evaluating: true,
        autoSubmitLoading: false,
        isSubject: true
    });
    const {
        resources: { llmConfig }
    } = useResources();
    const { customer, getCustomerData, isCustomerQuestionValid, addAutoSubmittedQuestion } = useCustomerContext();
    const { createMessage } = useCustomerMessageContext();

    const history = useHistory();

    React.useEffect(() => {
        if (customer.shouldAutoSubmit) {
            if (isCustomerQuestionValid() && !customer.autoSubmittedQuestions.includes(customer.question.value)) {
                setAutoSubmit({ evaluating: false, autoSubmitLoading: true });
                autoSubmitMessage();
            } else {
                setAutoSubmit({ ...autoSubmit, evaluating: false });
            }
        } else if (
            (llmConfig?.attribute.subjects && !customer.tenantSubject.value) ||
            (llmConfig?.attribute.capture_customer_surname && !customer.customerLastName.value)
        ) {
            setAutoSubmit({ ...autoSubmit, evaluating: false, isSubject: false });
        } else {
            setAutoSubmit({ ...autoSubmit, evaluating: false });
        }
    }, [customer.shouldAutoSubmit]);

    const autoSubmitMessage = () => {
        const customerData = getCustomerData();
        addAutoSubmittedQuestion(customerData.question);
        createMessage(customerData, newMsg => {
            history.push(`/conversation/${newMsg.messageId}/${newMsg.accessKey}/${false}`);
        });
    };

    return autoSubmit;
};
